/**
 * Table Row Component
 * Displays a single table in the tables list
 */

import { Edit2 } from 'lucide-react';
import React from 'react';
import { useAppSelector } from '../../../hooks/useRedux';
import { selectEffectiveOutlet } from '../../../store/outlets';
import { OutletTable } from '../../../types/section';

interface TableRowProps {
  canManage?: boolean;
  table: OutletTable;
  showOutletColumn: boolean;
  onEdit: (table: OutletTable) => void;
}

export const TableRow: React.FC<TableRowProps> = ({
  canManage = true,
  table,
  showOutletColumn,
  onEdit,
}) => {
  const selectedOutlet = useAppSelector(selectEffectiveOutlet);

  return (
    <tr className="border-b border-gray-100 hover:bg-gray-50/50 transition-colors">
      <td className="px-4 py-3">
        <span className="text-sm font-medium text-gray-900 uppercase">
          {table.name}
        </span>
      </td>
      {showOutletColumn ? (
        <td className="px-4 py-3">
          <span className="text-sm text-gray-600">
            {table.outlet_name || selectedOutlet?.name || '—'}
          </span>
        </td>
      ) : null}
      <td className="px-4 py-3">
        <span className="text-sm text-gray-600">
          {table.section_name || '—'}
        </span>
      </td>
      <td className="px-4 py-3 text-center">
        <span
          className={`text-sm font-medium ${
            table.is_hidden ? 'text-red-500' : 'text-green-500'
          }`}
        >
          {table.is_hidden ? 'HIDDEN' : 'YES'}
        </span>
      </td>
      <td className="px-4 py-3 text-right">
        {canManage ? (
          <button
            type="button"
            onClick={() => onEdit(table)}
            className="p-1.5 text-gray-400 hover:text-pos-primary hover:bg-pos-light/30 rounded-lg transition-colors"
            title="Edit table"
          >
            <Edit2 size={16} />
          </button>
        ) : null}
      </td>
    </tr>
  );
};
